let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jCHho")).then(() => parcelRequire('j1D9P'));